import { storage } from 'utils/firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import displayError from 'utils/displayError';
import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

/* ------DOCUMENTS CRUD------ */
export async function getOrgDocuments() {
  return fetcher.get({
    path: '/documents/organization',
  });
}

export async function createDocument({ name, folderId, organizationId, url }) {
  return fetcher.post({
    path: '/documents',
    body: { name, folderId, organizationId, url },
  });
}

export async function updateDocument(id, { name, folderId }) {
  return fetcher.put({
    path: `/documents/${id}`,
    body: { name, folderId },
  });
}

export async function deleteDocument({ id }) {
  return fetcher.delete({
    path: '/documents',
    body: { id },
  });
}

/* ------FILE STORAGE------ */
export async function uploadDocumentToStorage({ file, itemId, type = 'deal' }) {
  try {
    const storageRef = ref(storage, `documents/${type}-${itemId}/${file.name}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  } catch (error) {
    displayError({
      message: 'Failed to upload document. Please try again.',
      title: 'Upload Error',
    });
    throw error;
  }
}

export async function deleteDocumentFromStorage({ itemId, type = 'deal', fileName }) {
  try {
    const deleteRef = ref(storage, `documents/${type}-${itemId}/${fileName}`);
    await deleteObject(deleteRef);
  } catch (error) {
    displayError({
      message: 'Failed to delete document. Please try again.',
      title: 'Delete Error',
    });
    throw error;
  }
}
